import TweenMax from 'gsap/TweenMax';
import TimelineMax from 'gsap/TimelineMax';
import Sine from 'gsap';
import Typed from 'typed.js';

import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';

console.log(ScrollToPlugin);

/*
 * Helper functions
 */
//From http://www.quirksmode.org/js/events_properties.html#position
const get_mouse_pos = (e) => {
	let posx = 0;
	let posy = 0;
	if (!e) e = window.event;
	if (e.pageX || e.pageY) {
		posx = e.pageX;
		posy = e.pageY;
	}
	else if (e.clientX || e.clientY) 	{
		posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
		posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
	}
	return { x : posx, y : posy }
}

export function setupImageFx()
{
	let hoverItems = document.querySelectorAll('.mouse-trail');

	if(!hoverItems || hoverItems.length == 0)
	{
		return null;
	}

	hoverItems.forEach((item) => {
		if(item.querySelector('img'))
		{
			new hover_img_fx1(item);
		}
	});
}

// Effect 1
class hover_img_fx1 {
	constructor(el) {
		this.DOM = {el: el};
		this.DOM.reveal = el.querySelector('.mouse-trail__image');
		this.DOM.reveal.className = 'mouse-trail__image';
		this.DOM.revealInner = this.DOM.reveal.querySelector('.mouse-trail__inner');
		this.DOM.revealInner.style.overflow = 'hidden';
		this.DOM.revealImg = this.DOM.reveal.querySelector('img');

		this.initEvents();
	}
	initEvents() {
		this.positionElement = (ev) => {
			const mousePos = get_mouse_pos(ev);
			const docScrolls = {
				left : document.body.scrollLeft + document.documentElement.scrollLeft,
				top : document.body.scrollTop + document.documentElement.scrollTop,
			};
			this.DOM.reveal.style.top = `${(mousePos.y - docScrolls.top) - 112.5}px`;
			this.DOM.reveal.style.left = `${(mousePos.x - docScrolls.left) - 150}px`;
		};
		this.mouseenterFn = (ev) => {
			this.positionElement(ev);
			this.showImage();
		};
		this.mousemoveFn = ev => requestAnimationFrame(() => {
			this.positionElement(ev);
		});
		this.mouseleaveFn = () => {
			this.hideImage();
		};

		this.DOM.el.addEventListener('mouseenter', this.mouseenterFn);
		this.DOM.el.addEventListener('mousemove', this.mousemoveFn);
		this.DOM.el.addEventListener('mouseleave', this.mouseleaveFn);
	}
	showImage() {
		TweenMax.killTweensOf(this.DOM.revealInner);
		TweenMax.killTweensOf(this.DOM.revealImg);

		this.tl = new TimelineMax({
			onStart: () => {
				this.DOM.reveal.style.opacity = 1;
				TweenMax.set(this.DOM.el, {
					zIndex: 1,
				});
			},
		})
		.add('begin');
	}
	hideImage() {
		TweenMax.killTweensOf(this.DOM.revealInner);
		TweenMax.killTweensOf(this.DOM.revealImg);

		this.tl = new TimelineMax({
			onStart: () => {
				TweenMax.set(this.DOM.el, {
					zIndex: 999,
				});
			},
			onComplete: () => {
				TweenMax.set(this.DOM.el, {
					zIndex: '',
				});
				TweenMax.set(this.DOM.reveal, {opacity: 0});
			},
		})
		.add('begin');
	}
}

export function setInitialScrollPosition() {
	if (window.location.hash) {
		const id = window.location.hash;
		const headerHeightVar = getComputedStyle(document.documentElement)
		.getPropertyValue('--header-height') || 0;

		const headerHeight = headerHeightVar.replace('px', '');

		scroll_to_target(id, {
			instant: false,
			offset: parseInt(headerHeight),
		});
	}
}


export function scroll_to_target(target, config = {}) {
	const headerHeightVar = getComputedStyle(document.documentElement)
		.getPropertyValue('--header-height') || '0px';

	const headerHeight = headerHeightVar.replace('px', '');
	
	const {
		instant = false, // bool
		scrollWrapper = window, // element
		offset = parseInt(headerHeight), // number
		speed = 0.6,
	} = config;

	const duration = instant ? 0 : speed;

	TweenMax.to(scrollWrapper, duration, {
			scrollTo: {
				y: target,
				offsetY: offset,
				autoKill: false,
			},
		},
		Sine.easeOut
	);
}


// Expects a URL()
function link_is_same_page(url) {
	const linkLocation = url.origin + url.pathname;
	const windowLocation = window.location.origin + window.location.pathname;

	return linkLocation === windowLocation;
}

function _get_hash_links() {
	const allLinks = Array.from(document.querySelectorAll('a[href]'));
	const hashLinks = allLinks.filter(link => {
		const url = new URL(link.href);
		if (url.hash && link_is_same_page(url)) {
			return true;
		}

		return false;
	});

	return hashLinks;
}

function hash_link_click_delegate(e) {
	if ('a' === e.target.tagName.toLowerCase() && e.target.dataset.href) {
		const url = new URL(e.target.dataset.href);

		if (url.hash) {
			const hash = url.hash;

			console.log('test', url.hash)

			e.preventDefault();
			e.stopPropagation();

			scroll_to_target(hash);
		}
	}
}

function init_hash_links() {
	const hashLinks = _get_hash_links();

	hashLinks.forEach(link => {
		link.dataset.href = link.href;
		link.href = '';
	}, {passive: false});

	window.addEventListener('click', hash_link_click_delegate, {passive: false});
}

function cleanup_hash_links() {
	window.removeEventListener('click', hash_link_click_delegate);
}

export function initScrollingFeatures() {
	// init_hash_links();
}

export function unload_scrolling_features() {
	cleanup_hash_links();
}

export function siteLoader() {
	const loader = document.querySelector('.site-loader');

	if(!loader)
	{
		return;
	}

	// if(Cookies.get('visited'))
	// {
	// 	loader.classList.remove('active');
	// }

	const elements = loader.querySelectorAll('span');
	const timeline = new TimelineMax({
		onStart: () => {
			setTimeout(() => {
				loader.classList.remove('active');
			}, 1200 );
		},
		repeat: 0,
	});

	timeline.staggerTo(elements, 1.2,
		{
			maxWidth: '100%',
		},
		0.2
	);
}

export function setup_type_fx()
{
	let typewriter = document.querySelector('.landing-typewriter');

	if(!typewriter || typewriter === null)
	{
		return;
	}

	let words = typewriter.getAttribute('data-words') || 'Placelab';

	let wordArray = words.split('|');

	if(typewriter)
	{
		var typed = new Typed('.landing-typewriter', {
			strings: wordArray,
			typeSpeed: 20,
			backSpeed: 5,
			smartBackspace: true,
			loop: true,
			showCursor: false,
			cursorChar: '|',
			autoInsertCss: true,
		});
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/animations.js